<template>
  <div>
    <h3 style="margin-top: 0px;">
      Device Health
    </h3>
    <div data-v-6e458483="">
      <div class="diagnostic-health-popover">
        <div class="grid gap-h_s">
          <div class="span-12">
            <div class="flex justify-between">
              <label>Battery Status</label>
              <div v-if="battery.batteryPercentage!=null">
                <span>{{ battery.batteryPercentage }} %</span>
              </div>
              <div v-if="battery.batteryPercentage==null">
                <span>N/A</span>
              </div>
            </div>
          </div>
          <div
              v-if="battery.batteryVoltage"
              class="span-12">
            <div class="flex justify-between">
              <label>Vehicle Battery Voltage</label>
              <div>
                <span>{{ round(battery.batteryVoltage) }} V</span>
              </div>
            </div>
          </div>
          <div class="span-12">
            <div class="flex justify-between">
              <label>Temperature F/C</label>
              <div v-if="battery.currentTemperature">
                <span>{{ currentTemperature.fahrenheit }} F ({{ currentTemperature.celsius }} C)</span>
              </div>
              <div v-if="!battery.currentTemperature">
                <span>N/A</span>
              </div>
            </div>
          </div>
          <div
              v-if="battery.chargingState"
              class="span-12">
            <div class="flex justify-between">
              <label>Charging State</label>
              <div>
                <span>{{ battery.chargingState }}</span>
              </div>
            </div>
          </div>
          <div
              v-if="battery.chargerType"
              class="span-12">
            <div class="flex justify-between">
              <label>Charger Type</label><div><span class="diagnostic-field-value indicator-good">{{ battery.chargerType }}</span></div>
            </div>
          </div><div class="span-12">
            <div class="flex justify-between">
              <label>Motion State</label><div><span>{{ battery.currentMotionState }}</span></div>
            </div>
          </div>
        </div>
        <div
            class="flex justify-center"
            style="margin-top: 20px;">
          <span class="report-timestamp">{{ timestamp }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "BatteryStatus",
  props: {
    battery: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    currentTemperature: {
      get() {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        let temp_info = {};
        if (this.battery.currentTemperature) {
          temp_info = {
            celsius: this.round(this.battery.currentTemperature),
            fahrenheit: this.round(
              this.celciusToFahrenheit(this.battery.currentTemperature)
            ),
          };
        } else {
          temp_info = { status: "N/A" };
        }
        return temp_info;
      },
    },
    timestamp: {
      get() {
        let tm = this.battery.last_keep_alive;
        if (!tm) return;
        let tz = this.$store.getters["ui/currentTimezone"];
        return this.$moment.tz(tm, tz).format("MM/DD/YYYY - hh:mm A Z (z)");
      },
    },
  },
  methods: {
    celciusToFahrenheit(c) {
      return c * 1.8 + 32;
    },
    round(value) {
      return Math.round(value * 10) / 10;
    },
  },
};
</script>
